import { render, staticRenderFns } from "./RoomAliased.vue?vue&type=template&id=365dd546&"
import script from "./RoomAliased.vue?vue&type=script&lang=js&"
export * from "./RoomAliased.vue?vue&type=script&lang=js&"
import style0 from "./RoomAliased.vue?vue&type=style&index=0&id=365dd546&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports